module.exports = __webpack_public_path__ + "static/media/phagans-logo-2.f07816d0.png";